<template>
	<div class="row">
		<div class="col">
			<div class="calendar">
				<div class="calendar__header">
					<p>Classement</p>
					<span>1ère Ligue</span>
				</div>
				<div class="calendar__current-month">
					<p>{{currentMonth}}</p>
				</div>
				<vue-event-calendar :events="matchEvent" @month-changed="calendarMonthChanged">
					<template slot-scope="props">
						<ul class="calendar__next-match">
							<li v-for="(event, index) in props.showEvents" class="event-item">
								<div class="current-date">20</div>
								<div>
									<p class="teams">{{event.title}}</p>
									<p class="time">{{event.time}}</p>
									<p class="league">{{event.league}}</p>
								</div>
							</li>
						</ul>
					</template>
				</vue-event-calendar>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				matchEvent: [
					{
						date: '2018/08/08', // Required
						title: 'Meyrin FC vs LANCY FC', // Required
						time: 'Samedi 8 Juin 2018 - 16h',
						league: 'second league'
					},
					{
						date: '2018/08/08', // Required
						title: 'LANCY FC vs Barcelona', // Required
						time: 'Juin 8 Juin 2018 - 20h',
						league: '1ère Ligue'
					},
					{
						date: '2018/08/10', // Required
						title: 'LANCY FC vs Barcelona', // Required
						time: 'Juin 8 Juin 2018 - 20h',
						league: '1ère Ligue'
					}
				],
				monthNames: ["Janvier", "Février", "Mars", "Avril", "Mai", "Juin", "Juillet", "Août", "Septembre", "Octobre", "Novembre", "Décembre"],
				currentMonth: '',
			}
		},
		mounted() {
			this.calendarFindNumbers()
			this.$EventCalendar.toDate(this.matchEvent[0].date)
			this.currentMonth = this.monthNames[new Date().getMonth()]
		},
		methods: {
			calendarFindNumbers() {
				$('.date-num').removeClass('number');
				$('.date-num').each(function(el) {
					if ( $(this).text().match( /[0-9]/g) ) {
						$(this).addClass('number')
					}
				})
			},
		    calendarMonthChanged (data) {
				this.$nextTick(() => {
					this.calendarFindNumbers()
				})
				this.getCurrentMonth(data);
		    },
		    getCurrentMonth(data) {
		    	this.currentMonth = this.monthNames[parseInt(data.substr(0,2)) - 1]
		    }
		}
	}
</script>